import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { userLogin, clearAuthErrors } from 'store/modules/auth/actions'
import LoginComponent from 'bundles/LoginRegister/components/LoginComponent'

class LoginContainer extends PureComponent {
    componentDidMount() {
        const { loggedIn, error, clearAuthErrors } = this.props;

        if (!loggedIn && error) {
            clearAuthErrors();
        }
    }

    componentDidUpdate(prevProps) {
        const { loggedIn, history } = this.props;

        if (prevProps.loggedIn !== loggedIn) {
            history.push('/')
        }
    }

    render() {
        return (
            <LoginComponent
                {...this.props}
            />
        )
    }

}

const mapStateToProps = (state) => {
    return {
        error: state.auth.error,
        isFetching: state.auth.isFetching,
        loggedIn: state.auth.loggedIn,
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        userLogin: (email, password) => {
            dispatch(userLogin(email, password))
        },
        clearAuthErrors: () => {
            dispatch(clearAuthErrors())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer)